<template>
	<div class="toasts-wrap">
		<transition-group name="toast">
			<div
				v-for="toast in toasts"
				:key="toast.id"
				:class="['toast', toast.type]"
			>
				<div class="toast-title">
					{{ toast.isCustomToast ? capitalize(toast.title) : capitalize(toast.type) }}
				</div>
				<div v-if="!toast.vhtmlToastMessage" class="toast-message">
					{{ toast.message }}
				</div>
				<div v-else class="toast-message" v-html="toast.message" />
				<div
					:class="['toast-actions', 'flex', `${toast.isCustomToast && toast.isCustomAction ? 'justify-between' : 'justify-end'}`, toast.customClass]"
				>
					<button
						v-if="toast.isCustomToast && toast.isCustomAction"
						:class="['btn toast-btn', toast.type]"
						class="dismiss"
						@click.prevent="toast.actionCallback(() => close(toast.id))"
					>
						{{ toast.actionTitle }}
					</button>
					<button
						:class="['btn toast-btn', toast.type]"
						class="dismiss"
						@click.prevent="close(toast.id)"
					>
						{{ $tc('actions.dismiss') }}
					</button>
				</div>
			</div>
		</transition-group>
	</div>
</template>

<script>
import { capitalize, uniqueKey } from '~/assets/util/helpers'

export default {
	name: 'Toaster',
	data () {
		return {
			toasts: []
		}
	},
	created () {
		this.$toast.$on('toasts-open', this.show)
		this.$toast.$on('toasts-close-all', this.closeAll)
	},
	methods: {
		capitalize,

		show (toast) {
			const id = uniqueKey()
			const closeDuration = toast.duration || 5000

			this.toasts.push({
				...toast,
				id
			})

			setTimeout(() => this.close(id), closeDuration)
		},

		close (id) {
			const index = this.toasts.findIndex(t => t.id === id)

			if (index !== -1) {
				this.toasts.splice(index, 1)
			}
		},

		closeAll () {
			this.toasts = []
		}
	}
}
</script>

<style lang="scss">
	@import "../../assets/scss/base/basics";

	.toasts-wrap {
		position: fixed;
		top: 0;
		right: 10px;
		z-index: 1001;
	}

	.toast {
		position: relative;
		margin-top: 15px;
		margin-left: auto;
		margin-right: auto;
		border-radius: 7px;
		padding: 0 0 5px;
		max-width: 400px;
		min-width: 270px;
		z-index: 10;
		text-align: left;
		transition: 0.3s ease-in-out;
		cursor: pointer;
		overflow: hidden;

		.toast-title {
			padding: 7px 15px;
			font-size: 17px;
			font-weight: 500;
			border-radius: 7px 7px 0 0;
			color: #f3f3f3;
		}

		.toast-message {
			padding: 10px 15px;
			color: $secondary;
			font-size: 13px;
		}

		.toast-actions {
			text-align: right;
			padding: 0 15px 10px;

			.toast-btn {
				@extend %button;
				padding: .2rem 1rem;
				border-radius: 4px;
				color: $white;
				transition: 0.2s;
			}
		}

		&.info {
			background: hsl(240, 80%, 95%);

			.toast-title {
				background-color: rgba($dark-blue, 0.85);
			}

			.toast-btn {
				background-color: rgba($dark-blue, 0.6);
				border-color: rgba($dark-blue, 0.6);

				&:hover {

					background-color: rgba($dark-blue, 0.8);
					border-color: rgba($dark-blue, 0.8);
				}
			}
		}

		&.success {
			background: hsl(213, 80%, 95%);

			.toast-title {
				background-color: rgba($primary, 0.85);
			}

			.toast-btn {
				background-color: rgba($primary, 0.6);
				border-color: rgba($primary, 0.6);

				&:hover {

					background-color: rgba($primary, 0.8);
					border-color: rgba($primary, 0.8);
				}
			}
		}

		&.error {
			background: hsl(0, 80%, 95%);

			.toast-title {
				background-color: rgba($red, 0.85);
			}

			.toast-btn {
				background-color: rgba($red, 0.6);
				border-color: rgba($red, 0.6);

				&:hover {

					background-color: rgba($red, 0.8);
					border-color: rgba($red, 0.8);
				}
			}
		}
	}

	.toast-enter-active {
		transition: all 0.3s ease-in-out;
	}

	.toast-leave-active {
		transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.toast-leave-to, .toast-enter {
		opacity: 0;
		transform: translateX(100px);
	}
</style>
